import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SectionsService } from '../sections.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-edit-section',
  templateUrl: './edit-section.component.html',
  styleUrls: ['./edit-section.component.scss']
})
export class EditSectionComponent {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error
  errorIcon: string = environment.config.customNotifications.icons.error
  errorType: string = environment.config.customNotifications.icons.error

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl(this.data.name),
    slug: new FormControl(this.data.slug),
    observatii: new FormControl(''),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<EditSectionComponent>,
    private sectionService: SectionsService, 
    private notificationService: NotificationService,
    private authService: AuthService) {
      this.processToken();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: true
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token
      this.sectionService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const updatedSectionData = {
      name: this.form.get('name')?.value,
      slug: this.form.get('slug')?.value,
      observations: this.form.get('observatii')?.value,
      id: this.data.id,
    };

    this.sectionService.updateSection(updatedSectionData)
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe({
      next: () => {
        this.dialogRef.close({success:true})
      },
      error: (err) => {
        let errorMessage = environment.config.customNotifications.generalMessages.error;
        this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon)
      }
    })
  }

  onHttpError(res: any) {
    if (res.errors && res.errors.message && res.errors.message.length > 0) {
      res.errors.message.forEach((msg: string) => {
        this.notificationService.warningSwal(this.errorTitle, msg, this.errorIcon);
      });
    }
    else {
      let errorMessage = environment.config.customNotifications.generalMessages.error;
      this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon);
    }
  }
}
